<template>
    <div class="account-settings-info-view">
        <a-button icon="plus" @click="addPurview">新增用户角色</a-button>
        <span>&nbsp;&nbsp;&nbsp;</span>
        <a-button icon="edit" @click="editPurview">权限修改</a-button>

        <div style="height:10px"></div>
        <a-form :form="form">
            <a-table
                    :columns="userColumns"
                    :dataSource="businessUserList"
                    :pagination="false"
                    rowKey="id"
                    :scroll="{ y: 300 }"
                    bordered
            >
        <span slot="name" slot-scope="name,record">
          <img :src="record.face" style="width: 40px; vertical-align: middle;"/>
          <span v-if="record.cash_name">{{record.cash_name}}</span>
          <span v-else>{{record.name}}</span>
          ({{record.phone}})
        </span>

                <template slot="action" slot-scope="text,record,index">
                    <!--          <a href="javascript:;" @click="onPurviewSetting(record)">权限分配</a>-->
                    <!--          <a-divider type="vertical" />-->
                    <a-popconfirm
                            title="确定删除此人员吗"
                            @confirm="deleteUser(record,index)"
                            okText="确定"
                            cancelText="取消"
                    >
                        <a href="javascript:;">删除</a>
                    </a-popconfirm>
                </template>
                <template slot="footer" slot-scope="currentPageData">
                    <user-picker
                            style="width: 200px; margin-right: 10px;"
                            :formData="userFormData"
                            field="user_id"
                    />
                    <a-select
                            style="width: 200px; margin-right: 10px;"
                            v-model="userFormData.type"
                            placeholder="所属用户角色"
                    >
                        <a-select-option
                                :value="item.name"
                                v-for="(item,i) in purviewList"
                                :key="i"
                                @click="onSelectTypeAdd(item)"
                        >{{item.name}}
                        </a-select-option>
                        <!-- <a-select-option value="店员">店员</a-select-option> -->
                    </a-select>
                    <a-button icon="plus" @click="addUser">新增管理</a-button>
                </template>
            </a-table>
        </a-form>

        <a-modal
        :maskClosable="false"
                title="添加用户角色"
                :width="1000"
                style="top: 20px;"
                :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
                v-model="visible"
                @ok="handleChange"
        >
            <a-spin :spinning="saveLoading">
                <a-form
                        :form="form"
                        :label-col="{ span: 5 }"
                        :wrapper-col="{ span: 12 }"
                        @submit="handleChange"
                >
                    <a-select
                            style="width: 200px; margin-right: 10px;"
                            v-model="userFormData.type"
                            placeholder="用户角色"
                            v-if="userPurview.user_id>0"
                    >
                        <a-select-option
                                :value="item.name"
                                v-for="(item,i) in purviewList"
                                :key="i"
                                @click="onSelectType(item)"
                        >{{item.name}}
                        </a-select-option>
                        <!-- <a-select-option value="店员">店员</a-select-option> -->
                    </a-select>
                    <a-form-item label="用户角色名称" v-else>
                        <a-input
                                v-decorator="['note', { rules: [{ required: true, message: '请输入用户角色名称' }] }]"
                        />
                    </a-form-item>
                </a-form>
                <template>
                    <a-tree
                            v-if="hackReset"
                            checkable
                            :tree-data="userPurview.user_id>0 ? treeData2 :treeData"
                            :default-checked-keys="userCheckList"
                            @select="onSelect"
                            @check="onCheck"
                    >

                        <span slot="title0010" style="color: #1890ff">sss</span>
                    </a-tree>
                </template>
            </a-spin>
            <template slot="footer">
                <a-button key="cancel" @click="handleCancel">取消</a-button>
                <a-button key="forward" :loading="saveLoading" v-if="userPurview.user_id>0" type="primary"
                          @click="addUser">修改
                </a-button>
                <a-button key="forward" :loading="saveLoading" v-else type="primary" @click="handleChange">保存</a-button>

            </template>
        </a-modal>

        <a-modal
        :maskClosable="false"
                title="修改管理权限"
                :width="1000"
                style="top: 20px;"
                :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
                v-model="editVisible"
                @ok="handleChange"
        >
            <a-spin :spinning="saveLoading">
                <a-form
                        :form="form"
                        :label-col="{ span: 5 }"
                        :wrapper-col="{ span: 12 }"
                        @submit="handleChange"
                >
                    <a-select
                            style="width: 200px; margin-right: 10px;"
                            v-model="userFormData.type"
                            placeholder="所属用户角色"

                    >
                        <a-select-option
                                :value="item.name"
                                v-for="(item,i) in purviewList"
                                :key="i"
                                @click="onSelectType(item)"
                        >{{item.name}}
                        </a-select-option>
                        <!-- <a-select-option value="店员">店员</a-select-option> -->
                    </a-select>

                </a-form>
                <template>
                    <a-tree
                            v-if="hackReset"
                            checkable
                            defaultExpandParent
                            :tree-data="treeData"
                            :default-checked-keys="userCheckList"
                            @select="onSelect"
                            @check="onCheck"
                    >

                        <span slot="title0010" style="color: #1890ff">sss</span>
                    </a-tree>
                </template>
            </a-spin>
            <template slot="footer">
                <a-button key="cancel" @click="handleCancel">取消</a-button>
                <a-button key="forward" :loading="saveLoading" type="danger" @click="deleteRoleToPermission">删除
                </a-button>
                <a-button key="forwards" :loading="saveLoading" type="primary" @click="editRoleToPermission">修改
                </a-button>
            </template>
        </a-modal>
    </div>
</template>

<script>
    const treeData = [
        {
            title: "首页",
            // disableCheckbox: true ,
            disabled: true,
            key: "1",
            children: [
                {title: "分析页", key: "11"},
                {title: "销售分析页", key: "12"},
                {title: "设置", key: "13"}
            ]
        },
        {
            title: "用户管理",
            key: "2",
            children: [
                {title: "省市管理", key: "21"},
                {title: "用户管理", key: "22"},
                {title: "证件照管理", key: "23"},
                {title: "区域合伙人管理", key: "24"},
                {title: "裁判教练运动员", key: "25"},
                {title: "分销员", key: "26"},
                {title: "团队", key: "27"},
            ]
        },
        {
            title: "商品管理",
            key: "4",
            children: [
                {title: "线上商品", key: "27"},
                {title: "门店商品", key: "40"},
                {title: "商品评价", key: "41"},
                {title: "商品分类", key: "28"}
            ]
        },
        {
            title: "订单财务",
            key: "7",
            children: [
                {title: "订单管理", key: "29"},
                {title: "现金账户", key: "30"}
            ]
        },
        {
            title: "营销中心",
            key: "3",
            children: [
                {title: "拼团", key: "9"},
                // { title: "货到付款", key: "12" },
                {title: "优惠券", key: "10"},
                {title: "助力砍价", key: "8"},
                {title: "接龙", key: "11"},
                {title: "瓜分券", key: "13"},
                {title: "幸运抽奖", key: "15"},
                {title: "礼品券", key: "14"},
                {title: "会员特权卡", key: "12"}

            ]
        },
        {
            title: "设置",
            key: "5",
            children: [
                {title: "自提点管理", key: "42"},
                {title: "供应商管理", key: "32"},
                {title: "运费模版", key: "33"},
                {title: "页面管理", key: "34"},
                {title: "协议帮助", key: "35"},
                {title: "用户组", key: "36"},
                {title: "用户标签", key: "37"},
                // { title: "代理申请", key: "20" },
                // { title: "1.0代理数据", key: "21" },
                // { title: "分销员等级", key: "38" },
                {title: "站点设置", key: "39"}
            ]
        }
    ];
    const treeData2 = [
        {
            title: "仪表盘",
            // disableCheckbox: true ,
            disabled: true,
            key: "1"
        },
        {
            title: "用户管理",
            key: "2",
            children: [
                {title: "客户", key: "24"},
                {title: "分销员", key: "25"},
                {title: "团队", key: "26"}
            ]
        },
        {
            title: "商品管理",
            key: "4",
            children: [
                {title: "线上商品", key: "27"},
                {title: "门店商品", key: "40"},
                {title: "商品评价", key: "41"},
                {title: "商品分类", key: "28"}
            ]
        },
        {
            title: "订单财务",
            key: "7",
            children: [
                {title: "订单管理", key: "29"},
                {title: "现金账户", key: "30"}
            ]
        },
        {
            title: "营销中心",
            key: "3",
            children: [
                {title: "拼团", key: "9"},
                // { title: "货到付款", key: "12" },
                {title: "优惠券", key: "10"},
                {title: "助力砍价", key: "8"},
                {title: "接龙", key: "11"},
                {title: "瓜分券", key: "13"},
                {title: "幸运抽奖", key: "15"},
                {title: "礼品券", key: "14"},
                {title: "会员特权卡", key: "12"}

            ]
        },
        {
            title: "设置",
            key: "5",
            children: [
                {title: "自提点管理", key: "42"},
                {title: "供应商管理", key: "32"},
                {title: "运费模版", key: "33"},
                {title: "页面管理", key: "34"},
                {title: "协议帮助", key: "35"},
                {title: "用户组", key: "36"},
                {title: "用户标签", key: "37"},
                // { title: "代理申请", key: "20" },
                // { title: "1.0代理数据", key: "21" },
                // { title: "分销员等级", key: "38" },
                {title: "站点设置", key: "39"}
            ]
        }
    ];
    import {
        getBusinessUserList,
        getTreeData,
        deleteBusinessUser,
        addBusinessUser,
        getPurviewList,
        businessPurviewAdd,
        getUserPermission,
        roleDelete,
        businessPurviewEdit
    } from "@/api/business";
    import RSwitch from "@/components/RSwitch/";
    import UserPicker from "@/components/UserPicker/";

    export default {
        components: {
            RSwitch,
            UserPicker
        },
        data() {
            return {
                saveLoading: false,
                visible: false,
                editVisible: false,
                hackReset: true,
                autoExpandParent: true,
                treeData,
                treeData2,
                labelCol: {
                    xs: {span: 24},
                    sm: {span: 5}
                },
                wrapperCol: {
                    xs: {span: 24},
                    sm: {span: 16}
                },
                form: this.$form.createForm(this),

                //人员管理表头
                userColumns: [
                    {
                        title: "#",
                        dataIndex: "id",
                        width: "80px"
                    },
                    {
                        title: "用户名",
                        dataIndex: "cash_name",
                        scopedSlots: {customRender: "name"}
                    },
                    {
                        title: "角色",
                        width: "150px",
                        dataIndex: "role_type"
                    },
                    {
                        title: "操作",
                        dataIndex: "action",
                        width: "150px",
                        scopedSlots: {customRender: "action"}
                    }
                ],
                businessUserList: [],

                userFormData: {
                    user_id: undefined,
                    type: undefined,
                    id: undefined
                },
                checkedKeys: [],
                userCheckList: ["1"],
                purviewList: [],
                userPurview: {
                    user_id: 0,
                    role_id: 0
                }
            };
        },
        mounted() {
            let that = this;
            that.fetch();
        },
        methods: {
            onSelectType(item) {
                console.log(item);
                this.userFormData.id = item.id;
                this.getPurviewPermissionList(item.id);
                // this.visible = true;
            },
            onSelectTypeAdd(item) {
                console.log(item);
                this.userFormData.id = item.id;
            },
            //新增权限按钮
            addPurview() {
                this.userPurview.user_id = 0;
                this.checkedKeys = ['1']
                this.hackReset = false;
                this.$nextTick(() => {
                    this.hackReset = true;
                });
                this.visible = true;
            },
            //显示权限对应的菜单管理操作
            editPurview() {
                let that = this
                that.checkedKeys = ['1']
                that.hackReset = false;
                that.$nextTick(() => {
                    that.hackReset = true;
                })
                that.editVisible = true
            },
            //修改权限对应的菜单管理
            editRoleToPermission() {
                // console.log('修改')
                let that = this
                businessPurviewEdit({id: that.userFormData.id, purview: that.checkedKeys}).then(res => {
                    that.$message.success("修改成功!");
                    // that.userFormData.type=undefined
                    // that.userFormData.id=undefined
                    // that.checkedKeys=[]

                    // that.hackReset = false;
                    that.$nextTick(() => {
                        that.hackReset = true;
                    });
                    that.checkedKeys = ['1']
                })
            },
            deleteRoleToPermission() {
                console.log('删除')
                let that = this
                console.log(this.userFormData.id)
                if (that.userFormData.id == 999) {
                    that.$message.error("默认权限不可删除!");
                    return
                }
                this.$confirm({
                    title: '删除权限职位警告!',
                    content: '删除该权限后,权限下的人员会分配到默认权限',
                    onOk() {
                        roleDelete({id: that.userFormData.id}).then(res => {
                            // console.log(res)
                            that.$message.success("删除成功!");
                            // that.editVisible=false
                            that.userFormData.type = undefined
                            that.userFormData.id = undefined
                            that.checkedKeys = ['1']
                            // that.hackReset = false;
                            that.$nextTick(() => {
                                that.hackReset = true;
                            });
                            that.fetch();
                        })
                    },
                    onCancel() {
                    },
                });

            },
            onSelect(selectedKeys, info) {
                console.log("selected", selectedKeys);
            },
            onCheck(checkedKeys, info) {
                console.log("onCheck", checkedKeys);
                this.checkedKeys = checkedKeys;
            },
//权限分配
            onPurviewSetting(record) {
                console.log(record);
                this.userPurview.user_id = record.id;
                this.userPurview.role_id = record.role_id;
                this.userFormData.user_id = record.id
                this.getPurviewPermissionList(record.role_id);
                this.visible = true;
            },

            //新增权限操作
            handleChange(e) {
                e.preventDefault();
                this.form.validateFields((err, values) => {
                    if (!err) {
                        this.visible = false;
                        console.log(this.checkedKeys, e);
                        console.log("Received values of form: ", values);
                        businessPurviewAdd({
                            name: values.note,
                            purview: this.checkedKeys
                        }).then(res => {
                            console.log(res);
                            this.fetch()
                            this.visible = false

                        });
                    }
                });
            },
            handleCancel() {
                this.visible = false
                this.editVisible = false
            },
            fetch() {
                let that = this;
                getBusinessUserList().then(res => {
                    that.businessUserList = res.data.list;
                });
                getPurviewList().then(res => {
                    that.purviewList = res.data.list;
                });
                getTreeData().then(res => {
                    that.treeData = res.data;
                });
            },

            //添加用户权限
            addUser() {
                let self = this;
                if (!self.userFormData.user_id) {
                    self.$message.error("请选择人员");
                    return;
                }
                if (!self.userFormData.type) {
                    self.$message.error("请选择类型");
                    return;
                }
                console.log(self.userFormData);

                addBusinessUser(self.userFormData)
                    .then(res => {
                        self.userFormData.user_id = undefined;
                        self.userFormData.type = undefined;
                        self.$message.success("添加成功");
                        self.visible = false
                        self.fetch();
                    })
                    .catch(err => {
                        self.$message.error(err.data.msg);
                    });
            },
            deleteUser(record, index) {
                let self = this;
                deleteBusinessUser({
                    user_id: record.user_id
                })
                    .then(res => {
                        self.$message.success("删除成功");
                        self.businessUserList.splice(index, 1);
                    })
                    .catch(err => {
                        self.$message.error(err.data.msg);
                    });
            },
            //获取角色对象的权限操作
            getPurviewPermissionList(id) {
                let arr = [];
                getUserPermission({id: id}).then(res => {
                    console.log(res);
                    res.data.list.map(item => {
                        arr.push(item.permission_id + "");
                    });
                    this.userCheckList = arr;
                    console.log(this.userCheckList);
                    this.userFormData.type = res.data.name;
                    this.userFormData.id = id;
                    this.checkedKeys = arr;
                    this.hackReset = false;
                    this.$nextTick(() => {
                        this.hackReset = true;
                    });

                });

            }
        }
    };
</script>

<style lang="less" scoped>
    .avatar-upload-wrapper {
        height: 200px;
        width: 100%;
    }

    .ant-upload-preview {
        position: relative;
        margin: 0 auto;
        width: 100%;
        max-width: 180px;
        border-radius: 50%;
        box-shadow: 0 0 4px #ccc;

        .upload-icon {
            position: absolute;
            top: 0;
            right: 10px;
            font-size: 1.4rem;
            padding: 0.5rem;
            background: rgba(222, 221, 221, 0.7);
            border-radius: 50%;
            border: 1px solid rgba(0, 0, 0, 0.2);
        }

        .mask {
            opacity: 0;
            position: absolute;
            background: rgba(0, 0, 0, 0.4);
            cursor: pointer;
            transition: opacity 0.4s;

            &:hover {
                opacity: 1;
            }

            i {
                font-size: 2rem;
                position: absolute;
                top: 50%;
                left: 50%;
                margin-left: -1rem;
                margin-top: -1rem;
                color: #d6d6d6;
            }
        }

        img,
        .mask {
            width: 100%;
            max-width: 180px;
            height: 100%;
            border-radius: 50%;
            overflow: hidden;
        }
    }
</style>